define('../app/fukit/view/app.tasklist.view',['require','exports','module','uikit/uikit','backbone.radio','../blockit.shared','../helpers/route.helper','../config','../behavior/update.task.list.badge.options.behavior'],function(require, exports, module) {
  //prettier-ignore
  var UIKit       = require('uikit/uikit'),
      Radio       = require('backbone.radio'),
      BlocKit     = require('../blockit.shared'),
      RouteHelper = require('../helpers/route.helper'),
      config      = require('../config'),

      // Behaviors
      UpdateTaskListBadgeOptionsBehavior = require('../behavior/update.task.list.badge.options.behavior'),

      // Radio Channels
      TASKLIST_CHANNEL = Radio.channel('UI.taskList');

  var AppTaskListView = UIKit.Sidebar2.extend({
    className: UIKit.Sidebar2.prototype.className + ' tasklist',

    template: function() {
      return '<ui name="closeButtonView" /><ui class="sidebarButton" name="tabButtonView" /><ui name="contentView" />';
    },

    behaviors: {
      handleSideBarShowAndOpten: {
        behaviorClass: BlocKit.InvokeMethodOnEventBehavior,
        events: {
          'sidebar:show': {
            method: function() {
              var cayuseTaskListCollection = this.view.getCayuseTaskListCollection();

              // Stop the tasklist heartbeat so we don't update the list while the user is interacting with it
              this.view.clearTaskListHeartbeat();
              // Refresh with the latest data
              cayuseTaskListCollection.fetch();
            },
          },
          'sidebar:hide': {
            method: function() {
              // restart the tasklist heartbeat
              this.view.setTaskListHeartbeat();
            },
          },
        },
      },
    },

    options: _.extend({}, UIKit.Sidebar2.prototype.options, {
      destroyOnHidden: false,
      dimPage: false,
      size: 'very wide',
    }),

    internalViewOptions: {
      tabButtonView: {
        type: UIKit.Button.extend({
          className: UIKit.Button.prototype.className + ' task-list-tab-button',
        }),
        text: 'My Tasks',
        badge: false,
        badgeText: '',
        badgeColor: 'badge-gray',
        behaviors: {
          toggleTaskBar: {
            behaviorClass: BlocKit.InvokeMethodOnEventBehavior,
            events: {
              press: {
                method: function() {
                  var taskList = TASKLIST_CHANNEL.request('getTaskListSidebar');

                  taskList.isOpen() ? TASKLIST_CHANNEL.request('hide') : TASKLIST_CHANNEL.request('show');
                },
              },
            },
          },
          updateBadgeColorAndText: {
            behaviorClass: UpdateTaskListBadgeOptionsBehavior,
          },
        },
      },
      closeButtonView: {
        type: UIKit.Button.extend({
          attributes: {
            'aria-label': 'Close the My Tasks list',
          },
          className: UIKit.Button.prototype.className + ' icon minimal task-list-close-button',
        }),
        icon: 'close',
        iconRight: true,
        behaviors: {
          closeTaskBar: {
            behaviorClass: BlocKit.InvokeMethodOnEventBehavior,
            events: {
              press: {
                method: function() {
                  TASKLIST_CHANNEL.request('hide');
                },
              },
            },
          },
        },
      },
      contentView: function() {
        var cayuseTaskListCollection = this.getCayuseTaskListCollection();

        return {
          type: BlocKit.AttachedComponentsContainerView,
          components: [
            {
              type: UIKit.Header,
              text: 'My Tasks',
            },
            {
              type: UIKit.Table,
              collection: cayuseTaskListCollection,
              emptyText: 'You have no outstanding tasks.',
              columns: [
                {
                  text: 'Task',
                  link: '',
                  useInlineLink: true,
                  data: 'taskDescription',
                  behaviors: {
                    setTaskLink: {
                      behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                      optionValues: {
                        link: {
                          formatter: function(model) {
                            var routeOptions = model.getTaskRouteOptions();

                            return routeOptions ? RouteHelper.resolve(routeOptions.routeName, routeOptions.params) : '';
                          },
                        },
                      },
                    },
                  },
                },
                {
                  text: 'For',
                  link: '',
                  useInlineLink: true,
                  data: 'forDescription',
                  behaviors: {
                    setForLink: {
                      behaviorClass: BlocKit.BindAndFormatOptionValuesBehavior,
                      optionValues: {
                        link: {
                          formatter: function(model) {
                            var routeOptions = model.getForRouteOptions();

                            return routeOptions ? RouteHelper.resolve(routeOptions.routeName, routeOptions.params) : '';
                          },
                        },
                      },
                    },
                  },
                },
              ],
            },
          ],
        };
      },
    },

    initialize: function() {
      UIKit.Sidebar2.prototype.initialize.apply(this, arguments);

      // Radioify the show and hide methods for the sidebar so various embedded child views can invoke them
      TASKLIST_CHANNEL.reply('show', this.show, this);
      TASKLIST_CHANNEL.reply('hide', this.hide, this);
      // Allows embedded child views to access the context of the entire sidebar view
      TASKLIST_CHANNEL.reply(
        'getTaskListSidebar',
        function() {
          return this;
        },
        this
      );
      // Start the taskListHeartbeat
      this.setTaskListHeartbeat();
    },

    setTaskListHeartbeat: function() {
      var cayuseTaskListCollection = this.getCayuseTaskListCollection();
      var interval = config.get('task.list.fetch.interval') ? config.get('task.list.fetch.interval') : 180000; // Default is every 3 minutes

      if (cayuseTaskListCollection) {
        this.taskListHeartbeat = setInterval(function() {
          cayuseTaskListCollection.fetch();
        }, interval);
      }
    },

    clearTaskListHeartbeat: function() {
      clearInterval(this.taskListHeartbeat);
    },

    getCayuseTaskListCollection: function() {
      return Radio.request('AppKit.resourceService', 'resource', 'cayuseTaskListCollection');
    },

    isOpen: function() {
      return this.$el.hasClass('visible');
    },
  });
  module.exports = AppTaskListView;
});

